import { useMutation } from "urql";

import { UpdateTenantDocument } from "../../../graphql/generated.ts";

export function useUpdateTenant() {
  return useMutation(UpdateTenantDocument);
}
